import React, { useMemo } from "react";
import { Col, Container, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Link } from "react-router";
import { NAVIGATIONS } from "../../..";
import imageLists from "../../../assets/images/partner/list.json";
import { shuffleArray } from "../../../helpers";

interface IProps {
  data: Record<string, any>;
}

const COUNT_IMAGE = 8;

const FOLDERS = ["food_beverages", "hotel", "healthcare", "others"];

function ProductPartner({ data }: IProps) {
  const images = useMemo(() => {
    let images = Object.entries(imageLists)
      .filter(
        ([folderName, content]) =>
          FOLDERS.includes(folderName) && content !== null
      )
      .flatMap(([folderName, content]) => {
        return Object.values(content)
          .filter((entry: any) => entry.products.includes(`${data.product}`))
          .map((entry: any) => ({
            src: require(
              `../../../assets/images/partner/${folderName}/${entry.file}`
            ),
            products: entry.products,
            name: entry.image_name,
          }));
      })
    shuffleArray(images)
    return images.slice(0, COUNT_IMAGE);
  }, [data.product]); // Shuffle only when `data.product` changes

  return (
    <React.Fragment>
      <Container>
        <Row className="justify-content-center">
          <Col xl={10} lg={11} md={12}>
            <div className="my-5 text-center">
              <div className="fw-extra-bold text-size-sub-headline mb-1 text-secondary-dark">
                {data.title1}
              </div>
              <div className="fw-extra-bold text-size-title-2 mb-4 text-secondary-dark">
                {data.title2}
              </div>

              <div className="mt-2 text-size-sub-body-2 text-secondary">
                {data.titleDescription}
              </div>
            </div>
          </Col>
        </Row>
        <Row className="align-items-center text-center justify-content-center">
          {images.map((a, idx) => (
            <Col
              xl
              lg
              md={3}
              sm={4}
              xs={6}
              className="mt-4 mb-2"
              key={`partner-${idx}`}
            >
              <div className="">
                <OverlayTrigger overlay={
                  <Tooltip id={a.name}>
                    {a.name}
                  </Tooltip>
                }>
                  <Image src={a.src} fluid className="mt-2" />
                </OverlayTrigger>
              </div>
            </Col>
          ))}
          <div className="mt-2 text-size-sub-body-2 text-secondary">
            {data.description}
          </div>

          <div className="mt-4 text-center text-size-sub-body-2">
            <Link to={`${NAVIGATIONS.partner}?filter=${data.product}`}>Tampilkan Semua</Link>
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default ProductPartner;
